import React, {  Component } from 'react';
import { connect } from 'react-redux';

class NotHavingEnoughPointsOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('NotHavingEnoughPointsOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodYESOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>You don&#39;t have enough points to qualify your order for direct shipment.</p>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

NotHavingEnoughPointsOverlayDialog = connect(mapStateToProps)(NotHavingEnoughPointsOverlayDialog);
export default NotHavingEnoughPointsOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/notHavingEnoughPointsOverlayDialog.js